import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronGroup2FilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.082 5.19C4.004 4.613 4 3.985 4 3h2.4c0 1.021.007 1.474.06 1.87a6.8 6.8 0 0 0 4.019 5.327c.359.157.781.285 1.721.555v2.496c-.94.27-1.362.398-1.721.555A6.8 6.8 0 0 0 6.46 19.13c-.053.396-.06.849-.06 1.87H4c0-.986.004-1.613.082-2.19A9.2 9.2 0 0 1 8.718 12a9.2 9.2 0 0 1-4.636-6.81"
                fill="currentColor"
            />
            <path
                d="M11.882 5.19C11.805 4.613 11.8 3.985 11.8 3h2.4c0 1.021.007 1.474.06 1.87a6.8 6.8 0 0 0 4.019 5.327c.359.157.781.285 1.721.555v2.496c-.94.27-1.362.398-1.721.555a6.8 6.8 0 0 0-4.019 5.327c-.053.396-.06.849-.06 1.87h-2.4c0-.986.005-1.613.082-2.19A9.2 9.2 0 0 1 16.518 12a9.2 9.2 0 0 1-4.636-6.81"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronGroup2FilledSize24Glyph.displayName = 'ChevronGroup2FilledSize24Glyph';
